import React from "react";
import { Divider, Typography } from "antd";
import styles from "./holiday-leave.module.css";
import HolidayLeaveTabs from "./components/holiday-leave-tabs/holiday-leave-tabs";

const HolidayLeave = () => {

  return (
    <div className={styles.mainView}>
      <Typography className={styles.title}>Holiday & Leave</Typography>
       <Divider />
      <HolidayLeaveTabs />
    </div>
  );
};

export default HolidayLeave;
